module.exports = __webpack_public_path__ + "c8e5a844dd9dd5a2cf757a9b2ac3a507.svg";